import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
/**
 * @file
 * @author dailin01
 */
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import OutlinedDown from "acud-icon/es/icons/OutlinedDown";
import Button from '../button';
import { ConfigContext } from '../config-provider';
import Dropdown from './dropdown';
var ButtonGroup = Button.Group;
var DropdownButton = function DropdownButton(props) {
  var _classNames;
  var children = props.children,
    overlay = props.overlay,
    disabled = props.disabled,
    trigger = props.trigger,
    visible = props.visible,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'bottomRight' : _props$placement,
    customizePrefixCls = props.prefixCls,
    onClick = props.onClick,
    onVisibleChange = props.onVisibleChange,
    overlayClassName = props.overlayClassName,
    overlayStyle = props.overlayStyle,
    getPopupContainer = props.getPopupContainer,
    restProps = __rest(props, ["children", "overlay", "disabled", "trigger", "visible", "placement", "prefixCls", "onClick", "onVisibleChange", "overlayClassName", "overlayStyle", "getPopupContainer"]);
  // 菜单可见，需要将ICON旋转
  var _useState = useState(!!visible),
    _useState2 = _slicedToArray(_useState, 2),
    popupVisible = _useState2[0],
    setPopupVisible = _useState2[1];
  var mergedVisible = 'visible' in props ? visible : popupVisible;
  var handleVisibleChange = useCallback(function (visible) {
    if (!('visible' in props)) {
      setPopupVisible(visible);
    }
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(visible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls('btn-group', customizePrefixCls);
  var arrowCls = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-expand"), mergedVisible), _defineProperty(_classNames, "".concat(prefixCls, "-border-left"), restProps.type === 'primary'), _classNames));
  return /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, _extends({
    disabled: disabled,
    onClick: onClick
  }, restProps), children), /*#__PURE__*/React.createElement(Dropdown, {
    disabled: disabled,
    placement: placement,
    trigger: trigger,
    overlay: overlay,
    overlayClassName: overlayClassName,
    overlayStyle: overlayStyle,
    getPopupContainer: getPopupContainer,
    visible: mergedVisible,
    onVisibleChange: handleVisibleChange
  }, /*#__PURE__*/React.createElement(Button, _extends({
    disabled: disabled,
    className: arrowCls
    // aucdIcon span元素高度和svg不一致 TODO
    ,
    icon: /*#__PURE__*/React.createElement(OutlinedDown, {
      width: 16,
      height: 16,
      style: {
        height: 16
      }
    })
  }, restProps))));
};
export default DropdownButton;